import axios from 'axios'

import { type ApiResponse } from '~/shared/http-client/exceptions/type'

// Response Type
export interface FileUploadResponse extends ApiResponse {
  data: {
    errorCode: number
    errorMsg: string
    data: {
      file_list: {
        id: number
        parent_table_key: number
        original_name: string
        url: string
        created_at: string
        updated_at: string
        delete_yn: string
      }[]
    }
  }
}

// function
export const postFileUpload = async (file: File) => {
  const response: FileUploadResponse = await axios.post(
    import.meta.env.VITE_FILE_UPLOAD_ENDPOINT,
    { file },
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        data: 'data',
        encType: 'multipart/form-data',
        dataType: 'json',
        processData: false,
      },
    },
  )

  return response
}

export const postMultiPartFileUpload = async (file: File) => {
  const response: FileUploadResponse = await axios.post(
    import.meta.env.VITE_FILE_UPLOAD_ENDPOINT,
    { file },
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        data: 'data',
        encType: 'multipart/form-data',
        dataType: 'json',
        processData: false,
      },
    },
  )

  return response
}
